import React from "react";
import { Formik, Form, Field } from "formik";
import l from "components/util/l";

const FilesForm = ({ 
  zipFieldName,
  onClickDownloadZip = () => {} 
}) => {
  return <div className="card">
    <div class="card-header">
      <h3 class="mb-0">{"Descargar zip"}</h3>
    </div>
    <div class="card-body py-4">
      <Formik
        initialValues={{}}
        onSubmit={(values) => {
          onClickDownloadZip(zipFieldName, values.limit);
        }}
      >
        {({ values, setFieldValue }) =>
          <Form>

            <div class="form-group mb-4">
              <span class="d-flex justify-content-between dropdown-header pt-0 pb-2 px-0">
                <span style={{ color: "#777" }}>{l("Archivos%CA116")}</span>
              </span>
              <div class="input-group">
                <Field
                  as="select"
                  name="limit"
                  id="limit"
                  class="form-control"
                  required={true}
                >
                  <option value="">{l("Seleccione un límite%CA115")}</option>
                  <option value="15">{l("Últimos {count}%CA069", {count: 15})}</option>
                  <option value="30">{l("Últimos {count}%CA069", {count: 30})}</option>
                  <option value="50">{l("Últimos {count}%CA069", {count: 50})}</option>
                </Field>
              </div>
            </div>

            <div className="d-flex justify-content-between">
              <button
                type="submit"
                class="btn btn-block btn-primary mt-3"
              >
                {l("Descargar%GA027")}
              </button>

            </div>

          </Form>}
      </Formik>
    </div>
  </div>
}

export default FilesForm;